<template>

	<dialog-slot
			title="Edit exceptions"
			@updateClose="onCloseDialog"
			@updateSave="onSave"
			apply-text="Save"
			width="780px"
	>

		<template v-slot:subTitle>
			<div class="subTitleWrapEditException baseGray body-2">
				<tool-tip
						text="Date"
						content-class="top"
						custom-class="item"
						:position="{ top: 'top' }"
				>
					<svg-sprite icon-id="calendarAlt" width="22" height="22" class="text-green"></svg-sprite>
					<span>{{ exceptionItem.date }}</span>
				</tool-tip>

				<template v-if="exceptionItem.time">
					<tool-tip
							text="Time"
							content-class="top"
							custom-class="item"
							:position="{ top: 'top' }"
					>
						<svg-sprite icon-id="TimeFast" width="19" height="19" class="text-green"></svg-sprite>
						<span>{{ exceptionItem.time }}</span>
					</tool-tip>
				</template>

				<template v-if="statusName">
					<tool-tip
							text="Issue type"
							content-class="top"
							custom-class="item"
							:position="{ top: 'top' }"
					>
						<svg-sprite icon-id="warning" width="20" height="20" ></svg-sprite>
						<span >{{ statusName }}</span>
					</tool-tip>
				</template>
			</div>

		</template>
			<div class="exceptionHead">
				<div class="nameWrap">
					<item-info-row
							icon-id="icon-user"
							:is-item-text="false"
							:is-item-dashed="false"
							:value="exceptionItem.user"
							is-big-value
							is-flex-start
							custom-class="userName"
							margin="0"
					></item-info-row>

					<v-btn
							v-if="exceptionItem.file"
							@click="onViewFile(exceptionItem)"
					>
						<span class="btnIco mr-1"><svg-sprite color="#19bc38" icon-id="icon_view"/></span>
						<span class="btnText">View screenshot</span>
					</v-btn>
				</div>

				<div class="exceptionHead_description">
					<svg-sprite color="#19bc38" icon-id="icon-document"></svg-sprite>
					{{ exceptionItem.description }}
				</div>

			</div>

		<div class="exceptionBody">
			<div class="exceptionBody_top">
				<span class="exceptionBody_top-text">What was done</span>
				<button @click="onAddComment" class="exceptionBody_button">
					<svg-sprite width="18" height="18" icon-id="addItem"></svg-sprite>
					<span>Add comment</span>
				</button>
			</div>
			<main-table
					padding="0 0 20px"
					flag="exception"
					:headers="getHeaders"
					:list-items="exceptionActions"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[10, 20, 50, 100, 200, 500, 'All']"
					height="200"
			></main-table>
		</div>

		<template v-slot:subTitleFooter>
			<field
					margin="0"
					padding="0"
					label-switch="Done"
					:switch-value="status"
					@updateSwitch="onCheckbox"
					is-dense
					is-checkbox
					is-off-style
			></field>
		</template>
	</dialog-slot>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import { headers } from "@/components/Safety/Logbooks/EditException/constants";
// shared
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import ToolTip from "@/shared/ToolTip/ToolTip.vue";

export default {
	name: "EditException",
	components: { ToolTip, ItemInfoRow, DialogSlot },
	props: {
		editExceptionStatus: Boolean,
	},
	computed: {
		...mapGetters([ "exceptionItem", "exceptionActions", "exceptionStatus", ]),
		getHeaders() {
			return headers;
		},
	},
	data: () => ({
		status: false,
		statusName: null,
	}),
	methods: {
		...mapActions([ "onEditExceptionComment" ]),
		onCloseDialog() {
			this.$emit("updateCloseDialog");
		},
		onCheckbox({ value }) {
			this.status = value;
		},

		// async onSave(args) {
		// 	const { id } = this.exceptionItem;
		// 	const values = {
		// 		status: !this.status,
		// 		id,
		// 		actions: this.exceptionActions,
		// 	};
		// 	await this.onEditExceptionComment(values);
		// 	if (args) {
		// 		if (this.$refs.openTable) this.$refs.openTable.externalRefresh();
		// 		if (this.$refs.closeTable) this.$refs.closeTable.externalRefresh();
		// 	}
		// 	this.onCloseDialog();
		// },
		async onSave() {
			const { id } = this.exceptionItem;
			const values = {
				status: !this.status,
				id,
				actions: this.exceptionActions,
			};

			await this.onEditExceptionComment(values);

			this.$emit("updateRefreshExceptions");
			this.onCloseDialog();
		},
		onViewFile(item) {
			this.$emit("updateViewFile", item);
		},
		onAddComment() {
			this.$emit("updateAddComment");
		},
	},
	mounted() {
		this.status = this.editExceptionStatus;

		const found = this.exceptionStatus.find(item => item.id === this.exceptionItem.status_id);
		this.statusName = found ? found.name : null;
	},
};
</script>
<!--statusName() {-->
<!--const list = Array.isArray(this.exceptionStatus) ? this.exceptionStatus : [];-->
<!--const item = this.exceptionItem;-->

<!--if (!item || item.status_id == null) return null;-->

<!--const found = list.find(row => row.id === item.status_id);-->
<!--return found ? found.name : null;-->
<!--},-->
<style lang="scss">
.exceptionBody {
	.pageList--wrap.exception {
		padding: 0 !important;
	}
}
.subTitleWrapEditException {
	display: flex;
	align-items: center;
	gap: 10px;
	.item {
		display: flex;
		align-items: center;
		gap: 3px;
	}
}

</style>
<style scoped lang="scss">

.editExceptionHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;

  &_date {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
  }
}

.exceptionBottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exceptionBody {
  &_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;

    &-text {
      font-size: 20px;
      font-weight: 500;
      color: #fff;
    }
  }

  &_button {
    color: #19bc38;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
  }
}

.exceptionHead {
  color: #fff;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	display: flex;
	flex-direction: column;
	gap: 10px;

	.nameWrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	}

  &_title {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.8;
  }

  &_description {
	  display: flex;
	  align-items: flex-start;
	  gap: 4px;
	  font-size: 14px;
	  color: var(--card-color-sub-title);
	  * {
		  display: inline-block;
	  }
  }
}
</style>
